import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BllExpandComponent } from '../expand';
@Component({
  selector: 'bll-accordion',
  template: `<ng-content></ng-content>`,
})
export class BllAccordionComponent extends BllExpandComponent {
  @Input() iconClass: string;
  @Input() iconSize: number = 14;

  @Input()
  get iconCenter(): any {
    return this._iconCenter;
  }
  set iconCenter(value: any) {
    this._iconCenter = coerceBooleanProperty(value);
  }
  _iconCenter: boolean = true;

  @Input()
  get iconArrow(): any {
    return this._iconArrow;
  }
  set iconArrow(value: any) {
    this._iconArrow = coerceBooleanProperty(value);
  }
  _iconArrow: boolean;

  @Input()
  get paddingContent(): any {
    return this._paddingContent;
  }
  set paddingContent(value: any) {
    this._paddingContent = coerceBooleanProperty(value);
  }
  _paddingContent: boolean = true;
}
